import type { RouteRecordRaw } from 'vue-router'

const appRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/layouts/app/layout-app.vue'),
    children: [
      {
        path: '',
        name: 'dashboard',
        component: () => import('@/views/home/page-home.vue'),
      },
      {
        path: 'mobile',
        name: 'mobile home',
        component: () => import('@/views/mobile/home/page-home.vue'),
      },
      {
        path: 'mobile/profile',
        name: 'profile',
        component: () => import('@/views/mobile/profile/page-profile.vue'),
      },
      {
        path: 'mobile/pembelian',
        name: 'profile my purchase list',
        component: () => import('@/views/mobile/profile/page-my-purchase-list.vue'),
      },
      {
        path: 'mobile/simpanan',
        name: 'profile my saving list',
        component: () => import('@/views/mobile/profile/page-my-saving-list.vue'),
      },
      {
        path: 'mobile/keranjang',
        name: 'chart',
        component: () => import('@/views/mobile/chart/page-chart.vue'),
      },
      {
        path: 'mobile/simpanan/penarikan',
        name: 'saving withdrawal self',
        component: () => import('@/views/microfinance/saving-withdrawal-self/page-saving-withdrawal-self.vue'),
      },
      {
        path: 'mobile/pinjaman',
        name: 'profile my loan list',
        component: () => import('@/views/mobile/profile/page-my-loan-list.vue'),
      },
      {
        path: 'mobile/pinjaman/sendiri',
        name: 'loan self',
        component: () => import('@/views/microfinance/loan-self/page-loan-self.vue'),
      },
      {
        path: 'mobile/pinjaman/topup/sendiri',
        name: 'loan topup self',
        component: () => import('@/views/microfinance/loan-topup/self/page-loan-topup-self.vue'),
      },
      {
        path: 'mobile/pinjaman/simulasi',
        name: 'loan simulation',
        component: () => import('@/views/microfinance/loan-simulation/page-loan-simulation.vue'),
      },
      {
        path: 'mobile/notifikasi',
        name: 'mobile notification list',
        component: () => import('@/views/mobile/notification/page-notification-list.vue'),
      },
      {
        path: 'notifikasi',
        name: 'notificatiton list',
        component: () => import('@/views/notification/notification-list.vue'),
      },
    ],
  },
]

export { appRoutes }

